import athle from "../../assets/images_sports/athle.jpeg";
import bad from "../../assets/images_sports/bad.jpeg";
import basket from "../../assets/images_sports/basket.jpeg";
import boxe from "../../assets/images_sports/boxe.jpeg";
import cheer from "../../assets/images_sports/cheer.jpeg";
import dixK from "../../assets/images_sports/dixK.jpeg";
import equitation from "../../assets/images_sports/equitation.jpeg";
import escalade from "../../assets/images_sports/escalade.jpeg";
import escrime from "../../assets/images_sports/escrime.jpeg";
import foot from "../../assets/images_sports/foot.jpeg";
import hand from "../../assets/images_sports/hand.jpeg";
import judo from "../../assets/images_sports/judo.jpeg";
import natation from "../../assets/images_sports/natation.jpeg";
import pingpong from "../../assets/images_sports/pingpong.jpeg";
import rugby from "../../assets/images_sports/rugby.jpeg";
import spike from "../../assets/images_sports/spike.jpeg";
import petanque from "../../assets/images_sports/petanque.png";
import tennis from "../../assets/images_sports/tennis.jpeg";
import ultimate from "../../assets/images_sports/ultimate.jpeg";
import volley from "../../assets/images_sports/volley.jpeg";
import golf from "../../assets/images_sports/golf.jpeg";
import waterpolo from "../../assets/images_sports/waterpolo.jpeg";
import handitennis from "../../assets/images_sports/handitennis.jpeg";

// On importe les règlements

import athleRegle from "../../assets/reglement2026/AthleReglement.pdf";
import badRegle from "../../assets/reglement2026/BadReglement.pdf";
import basket1 from "../../assets/reglement2026/BasketMReglement.pdf";
import basket2 from "../../assets/reglement2026/BasketFReglement.pdf";
import boxeRegle from "../../assets/reglement2026/BoxeReglement.pdf";
import cheerRegle from "../../assets/reglement2026/CheerReglement.pdf";
import cheerQualif from "../../assets/reglement2026/CheerqualifReglement.pdf";
import dixKRegle from "../../assets/reglement2026/10kReglement.pdf";
import EquitationRegle from "../../assets/reglement2026/equitationReglement.pdf";
import escaladeRegle from "../../assets/reglement2026/EscaladeReglement.pdf";
import escrimeRegle from "../../assets/reglement2026/EscrimeReglement.pdf";
import foot1 from "../../assets/reglement2026/FootMReglement.pdf";
import foot2 from "../../assets/reglement2026/FootFReglement.pdf";
import hand1 from "../../assets/reglement2026/HandballMReglement.pdf";
import hand2 from "../../assets/reglement2026/HandballFReglement.pdf";
import judoRegle from "../../assets/reglement2026/JudoReglement.pdf";
import natationRegle from "../../assets/reglement2026/NatationReglement.pdf";
import petanqueRegle from "../../assets/reglement2026/PetanqueReglement.pdf";
import pingpongRegle from "../../assets/reglement2026/PingPongReglement.pdf";
import tennisRegle from "../../assets/reglement2026/TennisReglement.pdf";
import rugby1 from "../../assets/reglement2026/RugbyReglement.pdf";
import rugby2 from "../../assets/reglement2026/RugbyReglement.pdf";
import spikeRegle from "../../assets/reglement2026/SpikeReglement.pdf";
import ultimateRegle from "../../assets/reglement2026/UltimateReglement.pdf";
import Volley2 from "../../assets/reglement2026/VolleyFReglement.pdf";
import Volley1 from "../../assets/reglement2026/VolleyMReglement.pdf";
import golfRegle from "../../assets/reglement2026/GolfReglement.pdf";
import waterpoloRegle from "../../assets/reglement2026/WaterpoloReglement.pdf";
import handitennisRegle from "../../assets/reglement2026/HanditennisReglement.pdf";




const sportsImages = [
  {
    src: athle,
    title: "Athlétisme",
    id: 1,
    description: "12 équipes de 4 joueurs.",
    contact: "Sébastien Debarre",
    numero: "+33768857032",
    mail: "sebastien.debarre@student-cs.fr",
    reglement1: athleRegle,
    reglement2: "",
    sportFM: 0,
  },
  {
    src: bad,
    title: "Badminton",
    id: 2,
    description:
      "Simple Homme, Simple Femme, Double Homme, Double Femme, Double Mixte (double et simple pas compatible).",
    contact: "Pablo Miranda",
    numero: "+34638386672",
    mail: "pablo.mirandalasa@student-cs.fr",
    reglement1: badRegle,
    reglement2: "",
    sportFM: 0,
  },
  {
    src: basket,
    title: "Basketball Game",
    id: 3,
    description:
      "32 Équipes de 7 à 9 joueurs, jeu à 5 contre 5 sur le terrain.",
    description2:
      "16 Équipes de 6 à 9 joueuses, jeu à 5 contre 5 sur le terrain.",
    contact: "Gabin Lemarchand–Duc",
    numero: "+33640403750",
    mail: "gabin.lemarchandduc@student-cs.fr",
    contact2: "Jules Merillou",
    mail2: "jules.merillou@student-cs.fr",
    numero2: "+33684663868",
    reglement1: basket1,
    reglement2: basket2,
    sportFM: 1,
  },
  {
    src: boxe,
    title: "Boxe",
    id: 4,
    description: "80 participants, répartis en différentes catégories, tournoi d'assauts à élimination directe.",
    contact: "Marius Chatillon",
    numero: "+33783873969",
    mail: "marius.chatillon@student-cs.fr",
    reglement1: boxeRegle,
    reglement2: "",
    sportFM: 0,
  },
  {
    src: cheer,
    title: "Cheerleading/ Pompom",
    id: 5,
    description: "8 équipes en cheerleading entre 15 et 30 personnes.",
    description2: "8 équipes en pompom entre 15 et 30 personnes.",
    contact: " Marie Pinguet",
    numero: "+33625187930",
    mail: "marie.pinguet@student-cs.fr",
    contact2: "Maël Delaunay",
    mail2: "mael.delaunay@student-cs.fr",
    numero2: "+33785442780",
    reglement1: cheerRegle,
    reglement2: cheerQualif,
    sportFM: 1,
  },
  {
    src: dixK,
    title: "10Km Forvis Mazars",
    id: 6,
    description: "Participation individuelle (300 participant.e.s).",
    contact: "Nathan L'Hôte",
    numero: "+33767056985",
    mail: "nathan.l-hote@student-cs.fr",
    reglement1: dixKRegle,
    reglement2: "",
    sportFM: 0,
  },
  {
    src: equitation,
    title: "Equitation",
    id: 7,
    description: "15 Équipes de 3 cavalier.ère.s (mixte).",
    contact: "Sophia Diette",
    numero: "+33688712172",
    mail: "sophia.diette@student-cs.fr",
    reglement1: EquitationRegle,
    reglement2: "",
    sportFM: 0,
  },
  {
    src: escalade,
    title: "Escalade",
    id: 8,
    description: "80 paticipant.e.s (participation individuelle).",
    contact: "Kiruan Perez--Varas",
    numero: "+33699548339",
    mail: "kiruan.perezvaras@student-cs.fr",
    reglement1: escaladeRegle,
    reglement2: "",
    sportFM: 0,
  },
  {
    src: escrime,
    title: "Escrime",
    id: 9,
    description:
      "Tournois d'épée, de fleuret et de sabre de 90 personnes. Selon le format classique poules puis tableau à élimination directe",
    contact: (
      <>
        Alexandre Baetz<br />
        Loïc Perthuis
      </>
    ),
    numero: "+33633812835 +33667633307",
    mail: "alexandre.baetz@student-cs.fr loic.perthuis@student-cs.fr",
    reglement1: escrimeRegle,
    reglement2: "",
    sportFM: 0,
  },
  {
    src: foot,
    title: "Football",
    id: 10,
    description: "48 Equipes de 9 à 11 joueurs, jeu à 8 sur demi-terrain.",
    description2: "20 Équipes de 9 à 11 joueuses, foot à 8 sur demi-terrain.",
    contact: (
      <>
        Inès Archambeaud<br />
        Félicie Tripard
      </>
    ),
    numero: "+33642920581  +33616865372 ",
    mail: "ines.archambeaud@student-cs.fr felicie.tripard@student-cs.fr",
    contact2: "Antony Portes Wozniak",
    mail2: "antony.portes@student-cs.fr",
    numero2: "+33643817360",
    reglement1: foot1,
    reglement2: foot2,
    sportFM: 1,
  },
  {
    src: hand,
    title: "Handball",
    id: 11,
    description: "32 Équipes de 8 à 11 joueurs.",
    description2: "16 Équipes de 8 à 11 joueuses.",
    contact: "Yaël Kahn",
    numero: "+33769404212",
    mail: "yael.kahn@gmail.com",
    contact2: "Constentin Philipon",
    mail2: "constantin.philipon@student-cs.fr",
    numero2: "+33647284650",
    reglement1: hand1,
    reglement2: hand2,
    sportFM: 1,
  },
  {
    src: judo,
    title: "Judo",
    id: 12,
    description: "48 participant.e.s.",
    contact: "Clément Hochet",
    numero: "+33769623452",
    mail: "clement.hochet@student-cs.fr",
    reglement1: judoRegle,
    reglement2: "",
    sportFM: 0,
  },
  {
    src: natation,
    title: "Natation",
    id: 13,
    description: "Equipes de 4 personnes mixtes.",
    contact: (
      <>
        Aïnhoa Lamagnere<br />
        Tristan Hottier
      </>
    ),
    numero: "+33638967452",
    mail: "ainhoa.lamagnere@student-cs.fr tristan.hottier@student-cs.fr",
    reglement1: natationRegle,
    reglement2: "",
    sportFM: 0,
  },
  {
    src: pingpong,
    title: "Tennis de table",
    id: 14,
    description: "Participation individuelle, tournoi mixte.",
    contact: "Alice Lemaire",
    numero: "+33645595888",
    mail: "alice.lemaire@student-cs.fr",
    reglement1: pingpongRegle,
    reglement2: "",
    sportFM: 0,
  },
  {
    src: tennis,
    title: "Tennis",
    id: 15,
    description: "32 équipes mixte de 4 joueur.euse.s",
    contact: "Anthéa Legée",
    numero: "+33695133670",
    mail: "anthea.legee@student-cs.fr",
    reglement1: tennisRegle,
    reglement2: "",
    sportFM: 0,
  },
  {
    src: rugby,
    title: "Rugby",
    id: 16,
    description: "32 Équipes de 9 à 12 joueurs, rugby à 7.",
    description2: "16 Équipes de 9 à 12 joueuses, rugby à 7 sur grand terrain.",
    contact: "Arthur Vidy",
    numero: "+33783576578",
    mail: "arthur.vidy-montauban@student-cs.fr",
    contact2: "Marc-Antoine Vacarie",
    mail2: "marc-antoine.vacarie@student-cs.fr",
    numero2: "+33768062770",
    reglement1: rugby1,
    reglement2: rugby2,
    sportFM: 1,
  },
  {
    src: spike,
    title: "Spike",
    id: 17,
    description: "32 équipes de 2 joueurs.",
    contact: "Octave Desurmont",
    numero: "+33659686307",
    mail: "octave.desurmont@student-cs.fr",
    reglement1: spikeRegle,
    reglement2: "",
    sportFM: 0,
  },
    {
    src: petanque,
    title: "Pétanque",
    id: 23,
    description: "",
    contact: "Baptiste Le Tacon",
    numero: "+33766861591",
    mail: "baptiste.le-tacon@student-cs.fr",
    reglement1: petanqueRegle,
    reglement2: "",
    sportFM: 0,
  },
  {
    src: ultimate,
    title: "Ultimate",
    id: 18,
    description: "20 équipes de 7 à 10 joueur.euse.s (sport mixte).",
    contact: "Hugo Cagnon",
    numero: "+33652736151",
    mail: "hugo.cagnon@student-cs.fr",
    reglement1: ultimateRegle,
    reglement2: "",
    sportFM: 0,
  },
  {
    src: volley,
    title: "Volleyball",
    id: 19,
    description: "M: 48 Équipes de 6 à 9 joueurs.",
    description2:
      "40 équipes de 6 à 9 joueuses. 8 poules de 5 équipes puis 1/8 de finale.",
    contact: (
      <>
        Clotilde de Crémoux<br />
        Thomas Roux
      </>
    ),
    numero: "+33611501701  +33768733295",
    mail: "clotilde.decremoux@student-cs.fr    et   thomas.roux@student-cs.fr",
    contact2: "Charles Marolleau",
    mail2: "charles.marolleau@student-cs.fr",
    numero2: "+33689235232",
    reglement1: Volley1,
    reglement2: Volley2,
    sportFM: 1,
  },
  {
    src: golf,
    title: "Golf",
    id: 20,
    description: "",
    description2:
      "",
    contact: "Gregoire Buot",
    numero: "+33608115095",
    mail: "gregoire.buot@student-cs.fr",
    reglement1: golfRegle,
    reglement2: "",
    sportFM: 0,
  },
  {
    src: waterpolo,
    title: "Waterpolo",
    id: 21,
    description: "",
    description2:
      "",
    contact: "Paul Maréchal",
    numero: "+33630318707",
    mail: "paul.marechal@student-cs.fr",
    contact2: "",
    mail2: "",
    numero2: "",
    reglement1: waterpoloRegle,
    reglement2: "",
    sportFM: 0,
  },
  {
    src: handitennis,
    title: "Tennis-Fauteuil",
    id: 22,
    description: "",
    description2:
      "",
    contact: (
      <>
         Clotilde de Crémoux<br />
      </>
    ),
    numero: "+33611501701",
    mail: "clotilde.de-cremoux@student-cs.fr",
    contact2: "",
    mail2: "",
    numero2: "",
    reglement1: handitennisRegle,
    reglement2: "",
    sportFM: 0,
  },
];

export default sportsImages;
